import { api } from "../api";

/**
 * Fire-and-broadcast connect request.
 * @param {{ id: number, display_name?: string, name?: string, username?: string, avatar_url?: string, profile_pic_url?: string, photo_url?: string }} addressee
 * @param {() => Record<string,string>} [authHeaders]  optional headers helper
 * @returns {Promise<{status:string, connection_id?:number}>}
 */
export async function requestConnection(addressee, authHeaders) {
  const res = await api.post(
    "/connections/request",
    { addressee_id: addressee.id },
    { headers: authHeaders?.() || {}, withCredentials: true }
  );

  const data = res?.data || {};

  // Immediately notify the bell
  window.dispatchEvent(
    new CustomEvent("connections:outgoing", {
      detail: {
        connection_id: data.connection_id, // may be undefined if backend doesn't return it
        status: data.status,               // "pending_out" | "accepted" | etc.
        addressee: {
          id: addressee.id,
          display_name:
            addressee.display_name ||
            addressee.name ||
            addressee.username ||
            (addressee.id ? `User ${addressee.id}` : "User"),
          avatar_url:
            addressee.avatar_url ||
            addressee.profile_pic_url ||
            addressee.photo_url ||
            null,
        },
      },
    })
  );

  return data;
}
